/**
 * Compares two objects and returns only the changed fields in patch format
 * @param {Object} originalSettings - The original settings object
 * @param {Object} updatedSettings - The updated settings object
 * @returns {Array} - Array of patch objects with path and value properties
 */
export const getChangedFields = (originalSettings, updatedSettings) => {
  if (!originalSettings || !updatedSettings) {
    return []
  }

  const changes = []

  // Compare each field in updatedSettings with originalSettings
  Object.keys(updatedSettings).forEach(key => {
    const originalValue = originalSettings[key]
    const updatedValue = updatedSettings[key]

    // Check if the value has changed
    // Handle different data types appropriately
    if (JSON.stringify(originalValue) !== JSON.stringify(updatedValue)) {
      changes.push({
        path: key,
        value: updatedValue,
      })
    }
  })

  return changes
}

/**
 * Maps settings object to patch format for landing page settings
 * This function maps the settings field names to the corresponding patch paths
 * @param {Object} settings - The settings object
 * @returns {Object} - Object with mapped field names
 */
export const mapSettingsToPatchFormat = settings => {
  if (!settings) return {}

  return {
    primaryColor: settings.primaryColor,
    favicon: settings.favicon,
    font: settings.font,
    logo: settings.logo,
    thumbnail: settings.thumbnail,
    description: settings.cardDescription,
    seoTitle: settings.seoTitle,
    seoKeywords: settings.seoKeywords,
    seoDescription: settings.seoDescription,
    seoIndexable: settings.seoIndexable,
    headerScripts: settings.headerScript,
    bodyScripts: settings.bodyScript,
  }
}
